import React from "react";

type U2000ActionBtnProps = {
  label: React.ReactNode;
  handleClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
  disabled?: boolean;
  hasRole?: boolean;
  icon?: React.ComponentType<React.SVGProps<SVGSVGElement>>;
  className?: string;
  title?: string;
  /** Pastille ou libellé court affiché à droite du libellé (ex. raccourci F3). */
  trailingHint?: React.ReactNode;
  /** `secondary` : bouton discret (ex. Annuler) ; défaut = action primaire bleue. */
  variant?: "primary" | "secondary";
  onMouseDown?: (event: React.MouseEvent<HTMLButtonElement>) => void;
};

const primaryClass =
  "inline-flex items-center justify-center rounded-lg bg-blue-600 px-4 py-2.5 text-sm font-medium text-white shadow-xs transition-all duration-200 hover:bg-blue-700 hover:shadow-md focus:outline-hidden focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 active:bg-blue-800 active:scale-95 disabled:cursor-not-allowed disabled:bg-gray-400 disabled:text-gray-200 disabled:opacity-60 disabled:shadow-none";

const secondaryClass =
  "inline-flex items-center justify-center rounded-lg border border-gray-300 bg-white px-4 py-2.5 text-sm font-medium text-gray-800 shadow-xs transition-all duration-200 hover:bg-gray-50 focus:outline-hidden focus:ring-2 focus:ring-blue-500/40 focus:ring-offset-2 active:scale-95 disabled:cursor-not-allowed disabled:border-gray-200 disabled:bg-gray-100 disabled:text-gray-400 disabled:opacity-60";

const U2000ActionBtn: React.FC<U2000ActionBtnProps> = ({
  label,
  handleClick,
  disabled,
  hasRole,
  icon: Icon,
  className,
  title,
  trailingHint,
  variant = "primary",
  onMouseDown,
}) => {
  if (hasRole !== undefined && hasRole === false) {
    return null;
  }

  return (
    <button
      type="button"
      className={`${variant === "secondary" ? secondaryClass : primaryClass} ${className ?? ""}`}
      onMouseDown={onMouseDown}
      onClick={handleClick}
      disabled={disabled}
      title={title}
    >
      {Icon && <Icon className="mr-2 h-4 w-4 shrink-0" />}
      <span className="inline-flex items-center gap-2">
        <span>{label}</span>
        {trailingHint}
      </span>
    </button>
  );
};

export default U2000ActionBtn;
